import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import { FormButton } from '../Button';
import { DialogContent, DialogActions } from '@mui/material';
import { useTranslation } from 'react-i18next';

type PopupConfirmSilenceProps = {
  open: boolean;
  message?: string;
  description?: string;
  handleClick: () => void;
  handleClose: () => void;
};

const PopupConfirmSilence = ({
  open,
  message,
  description,
  handleClick,
  handleClose,
}: PopupConfirmSilenceProps) => {
  const { t } = useTranslation();
  const m = t('popup-delete-title');
  const d = t('popup-delete-description');

  return (
    <TransparentDialog onClose={handleClose} open={open}>
      <DialogTitleContainer>{message || m}</DialogTitleContainer>
      <DialogContentContainer>
        <p>{description || d}</p>
      </DialogContentContainer>
      <DialogActionsContainer>
        <FormButton
          buttonLabel={t('button-cancel')}
          color={'grey'}
          OnClick={handleClose}
          style={{
            marginRight: 10,
            borderRadius: 6,
            border: '1px solid #F0F0F0',
          }}
        />
        <FormButton
          buttonLabel={t('button-confirm')}
          color={'primary'}
          OnClick={handleClick}
          style={{
            borderRadius: 6,
          }}
        />
      </DialogActionsContainer>
    </TransparentDialog>
  );
};

const TransparentDialog = styled(Dialog)(() => ({
  '& .MuiBackdrop-root': {
    backgroundColor: '#00000033',
  },
  '& .MuiDialog-paper': {
    borderRadius: 16,
  },
}));

const DialogTitleContainer = styled(DialogTitle)(() => ({
  paddingTop: 32,
  paddingInline: 48,
}));

const DialogContentContainer = styled(DialogContent)(() => ({
  paddingTop: '32px !important',
  paddingInline: 30,
  paddingBottom: 32,
}));

const DialogActionsContainer = styled(DialogActions)(() => ({
  paddingInline: 48,
  paddingBottom: 32,
}));

export default PopupConfirmSilence;
